import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const AnimationsActionTypes = Object.freeze({
  ODDS_TRAVEL_PUSH: 'ANIMATIONS:ODDS_TRAVEL_PUSH',
  ODDS_TRAVEL_POP: 'ANIMATIONS:ODDS_TRAVEL_POP',
  TOGGLE_ODDS_TRAVEL_OPTION: 'ANIMATIONS:ODDS_TRAVEL_TOGGLE_OPTION',
});
export type AnimationActionType = ObjectValuesUnionType<typeof AnimationsActionTypes>;
